export const eventVersion = ["1.0.0"];
